import dom from '../../../helpers/dom';
import styles from '../../../helpers/styles';

const wrapperClass = 'js-comment-wrapper';
const formClass = 'js-comment-form';
const submitClass = 'js-comment-form-submit';
const DUPLICATE_COMMENT_PATTERN = /Duplicate comment detected/i;
const LONG_NAME_PATTERN = /Your name is too long/i;

const getTranslations = () => window.commentFormTranslations || {
  success: 'Thanks! Your comment is under review.',
  duplicate: 'Oops! You’ve already submitted that comment.',
  generic: 'Something went wrong. Please try again.',
  nameLong: 'The name entered is too long.',
};

const announce = (type) => {
  const messages = getTranslations();
  const message = messages[type];
  const region = dom.getFirstByClassName('js-comment-live-region');
  const text = dom.getFirstByClassName('js-comment-live-text');
  if (!region || !text || !message) return;

  region.classList.remove('rck-alert-box--success', 'rck-alert-box--error');

  if (type === 'success') {
    region.classList.add('rck-alert-box--success');
  } else {
    region.classList.add('rck-alert-box--error');
  }

  text.textContent = message;
  styles.showElement(region);
};

const handleSubmit = async (formEl) => {
  const form = formEl;
  const submitBtn = dom.getFirstByClassName(submitClass, form);
  const formData = new FormData(form);

  if (submitBtn) {
    submitBtn?.setAttribute('disabled', 'true');
    submitBtn.classList.add('rck-btn--loading');
  }

  try {
    const res = await fetch(form.action, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      // avoid redirects from wp-comments-post.php
      redirect: 'manual',
    });

    if (
      res.type === 'opaqueredirect'
      || res.status === 0
      || res.status === 302
    ) {
      form.innerHTML = '';
      announce('success');
      return;
    }

    const html = await res.text();
    if (DUPLICATE_COMMENT_PATTERN.test(html)) {
      announce('duplicate');
      return;
    }

    if (LONG_NAME_PATTERN.test(html)) {
      announce('nameLong');
      return;
    }

    if (/<title>.*(error|failure).*<\/title>/i.test(html)) {
      announce('generic');
      return;
    }

    announce('generic');
  } catch (err) {
    announce('generic');
  } finally {
    submitBtn?.removeAttribute('disabled');
    submitBtn.classList.remove('rck-btn--loading');
  }
};

const comments = () => {
  const init = () => {
    const wrapper = dom.getFirstByClassName(wrapperClass);
    const form = dom.getFirstByClassName(formClass, wrapper);

    if (!form) return;

    const region = dom.getFirstByClassName('js-comment-live-region', wrapper);
    if (region) styles.hideElement(region, true);

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      handleSubmit(form);
    });
  };

  return { init };
};

export default comments();
